import { c as _c } from "react/compiler-runtime";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { cn } from "@/utils/helpers";
import Image from "next/image";
import Link from "next/link";
import ErrorFallback from "../layout/error-fallback";
interface ListContainerProps {
  title: string;
  children: React.ReactNode;
  emptyMessage?: string;
  isEmpty?: boolean;
  viewAllHref?: string;
  variant?: "transparent" | "card";
  className?: string;
}
export function ListContainer(t0) {
  const $ = _c(21);
  const {
    title,
    children,
    emptyMessage: t1,
    isEmpty: t2,
    viewAllHref,
    variant: t3,
    className
  } = t0;
  const emptyMessage = t1 === undefined ? "No items to display" : t1;
  const isEmpty = t2 === undefined ? false : t2;
  const variant = t3 === undefined ? "transparent" : t3;
  const t4 = variant === "card" ? "border bg-card" : "";
  let t5;
  if ($[0] !== className || $[1] !== t4) {
    t5 = cn("relative flex w-full flex-grow flex-col overflow-hidden rounded-xl", t4, className);
    $[0] = className;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = variant === "card" ? "border-b px-4" : "";
  let t7;
  if ($[3] !== t6) {
    t7 = cn("flex items-center justify-between py-5", t6);
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== title) {
    t8 = <h3 className="ml-2 text-xl font-bold tracking-tight">{title}</h3>;
    $[5] = title;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== viewAllHref) {
    t9 = viewAllHref && <Link href={viewAllHref} className="text-sm font-medium text-primary hover:underline">View all</Link>;
    $[7] = viewAllHref;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t7 || $[10] !== t8 || $[11] !== t9) {
    t10 = <div className={t7}>{t8}{t9}</div>;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== children || $[14] !== emptyMessage || $[15] !== isEmpty) {
    t11 = isEmpty ? <ErrorFallback>{emptyMessage}</ErrorFallback> : children;
    $[13] = children;
    $[14] = emptyMessage;
    $[15] = isEmpty;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t5) {
    t12 = <div className={t5}>{t10}{t11}</div>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t5;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
}
interface VerticalListProps<T> {
  items: T[];
  renderItem: (item: T) => React.ReactNode;
  variant?: "transparent" | "card";
}
export function VerticalList(t0) {
  const $ = _c(10);
  const {
    items,
    renderItem,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "transparent" : t1;
  const t2 = variant === "card" ? "px-3 py-4" : "px-2 py-3";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("flex flex-col gap-1", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== items || $[3] !== renderItem) {
    let t5;
    if ($[5] !== renderItem) {
      t5 = (item, index) => <li key={index}>{renderItem(item)}</li>;
      $[5] = renderItem;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t4 = items.map(t5);
    $[2] = items;
    $[3] = renderItem;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <ul className={t3}>{t4}</ul>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
interface HorizontalGridProps<T> {
  items: T[];
  renderItem: (item: T) => React.ReactNode;
  maxItems?: number;
  variant?: "transparent" | "card";
}
export function HorizontalGrid(t0) {
  const $ = _c(13);
  const {
    items,
    renderItem,
    maxItems,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "transparent" : t1;
  let t2;
  if ($[0] !== items || $[1] !== maxItems) {
    t2 = maxItems ? items.slice(0, maxItems) : items;
    $[0] = items;
    $[1] = maxItems;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const displayItems = t2;
  const t3 = variant === "card" ? "px-3 py-4" : "";
  let t4;
  if ($[3] !== t3) {
    t4 = cn("hide-scrollbar flex gap-4 overflow-x-auto", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== displayItems || $[6] !== renderItem) {
    let t6;
    if ($[8] !== renderItem) {
      t6 = (item, index) => <li key={index} className="flex-shrink-0">{renderItem(item)}</li>;
      $[8] = renderItem;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    t5 = displayItems.map(t6);
    $[5] = displayItems;
    $[6] = renderItem;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <ul className={t4}>{t5}</ul>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
interface ListItemProps {
  title: string;
  subtitle: string;
  thumbnailUrl?: string;
  href: string;
  variant?: "list" | "grid";
}
export function ListItem(t0) {
  const $ = _c(36);
  const {
    title,
    subtitle,
    thumbnailUrl,
    href,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "list" : t1;
  if (variant === "list") {
    let t2;
    if ($[0] !== thumbnailUrl || $[1] !== title) {
      t2 = thumbnailUrl && <Image src={thumbnailUrl} alt={`Thumbnail image of chapter: ${title}`} fill={true} className="object-cover" />;
      $[0] = thumbnailUrl;
      $[1] = title;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <CardHeader className="relative aspect-video h-full overflow-hidden rounded-md bg-muted p-0">{t2}</CardHeader>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== title) {
      t4 = <p className="text-sm font-semibold">{title}</p>;
      $[5] = title;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== subtitle) {
      t5 = <p className="text-xs text-muted-foreground">{subtitle}</p>;
      $[7] = subtitle;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== t4 || $[10] !== t5) {
      t6 = <CardContent className="p-0">{t4}{t5}</CardContent>;
      $[9] = t4;
      $[10] = t5;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t3 || $[13] !== t6) {
      t7 = <Card className="flex h-full cursor-pointer items-center gap-3 rounded-xl border-0 bg-transparent p-2 hover:bg-muted">{t3}{t6}</Card>;
      $[12] = t3;
      $[13] = t6;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== href || $[16] !== t7) {
      t8 = <Link href={href}>{t7}</Link>;
      $[15] = href;
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    return t8;
  } else {
    if (variant === "grid") {
      let t2;
      if ($[18] !== thumbnailUrl || $[19] !== title) {
        t2 = thumbnailUrl && <Image src={thumbnailUrl} alt={`Thumbnail image of chapter: ${title}`} fill={true} sizes="400px" className="object-cover" />;
        $[18] = thumbnailUrl;
        $[19] = title;
        $[20] = t2;
      } else {
        t2 = $[20];
      }
      let t3;
      if ($[21] !== t2) {
        t3 = <CardHeader className="relative aspect-video w-full overflow-hidden bg-muted p-0">{t2}</CardHeader>;
        $[21] = t2;
        $[22] = t3;
      } else {
        t3 = $[22];
      }
      let t4;
      if ($[23] !== title) {
        t4 = <p className="line-clamp-1 font-semibold">{title}</p>;
        $[23] = title;
        $[24] = t4;
      } else {
        t4 = $[24];
      }
      let t5;
      if ($[25] !== subtitle) {
        t5 = <p className="line-clamp-2 text-sm text-muted-foreground">{subtitle}</p>;
        $[25] = subtitle;
        $[26] = t5;
      } else {
        t5 = $[26];
      }
      let t6;
      if ($[27] !== t4 || $[28] !== t5) {
        t6 = <CardContent className="flex flex-col gap-1 px-4 py-4">{t4}{t5}</CardContent>;
        $[27] = t4;
        $[28] = t5;
        $[29] = t6;
      } else {
        t6 = $[29];
      }
      let t7;
      if ($[30] !== t3 || $[31] !== t6) {
        t7 = <Card className="h-full w-72 cursor-pointer overflow-hidden transition hover:border-gray-400">{t3}{t6}</Card>;
        $[30] = t3;
        $[31] = t6;
        $[32] = t7;
      } else {
        t7 = $[32];
      }
      let t8;
      if ($[33] !== href || $[34] !== t7) {
        t8 = <Link href={href}>{t7}</Link>;
        $[33] = href;
        $[34] = t7;
        $[35] = t8;
      } else {
        t8 = $[35];
      }
      return t8;
    } else {
      return null;
    }
  }
}